import { render, staticRenderFns } from "./TargetSelector.vue?vue&type=template&id=457c09cb&scoped=true&"
import script from "./TargetSelector.vue?vue&type=script&lang=js&"
export * from "./TargetSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c09cb",
  null
  
)

export default component.exports